<template>
    <div class="login">
        <div class="login-container">
            <h1 class="login-caption">LOGIN</h1>
            <div class="login-from">
                <el-form :model="numberValidateForm" ref="numberValidateForm" class="demo-ruleForm">
                    <!-- 登录邮箱 -->
                    <el-form-item label="" prop="email" :rules="[
                        { required: true, message: '请输入邮箱地址'},
                        { type: 'email', message: '请输入正确的邮箱地址'}
                      ]">
                        <i class="el-icon-s-custom"></i>
                        <el-input type="email" v-model.email="numberValidateForm.email" placeholder="请输入正确的邮箱地址"
                            autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- 登录密码 -->
                    <el-form-item label="" prop="pass" :rules="[
                      {required: true,message:'请输入您的密码'},
                      { min: 6, message: '密码不少于6位', trigger: 'blur' }
                    ]">
                        <i class="el-icon-lock"></i>
                        <el-input type="password" v-model="numberValidateForm.pass" placeholder="请输入密码"
                            autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="login-button" @click='login'>Submit</div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Login',
        data() {
            return {
                // 表单的内容双绑定
                numberValidateForm: {
                    email: '',
                    pass: ''
                },
            }
        },
        methods: {
            login() {
                console.log(1)
                this.$axios.post(this.$API.login, {
                    "grant_type": "password",
                    "client_id": 2,
                    "client_secret": "eq5Ex2NcSuRs1FO9oT0vIxaSjNORaUTbksyBOca9",
                    "username": this.numberValidateForm.email,
                    "password": this.numberValidateForm.pass,
                    "scope": ""
                })
                .then(res=>{
                    // 登录，并将token保存到sessionStorage中
                    window.sessionStorage.setItem('langjing-admin-token',res.data.token_type+' '+res.data.access_token)
                    // 登录成功后跳转页面到系统界面
                    this.$router.push('/admin')
                })
                .catch(err=>{
                    //捕获后端的错误
                    this.$message.error('错了哦，请好好核对您的账户密码');
                })
            }
        }
    }
</script>
<style scoped>
    /* 登录页面的背景颜色 */
    .login {
        height: 100vh;
        background-image: linear-gradient(to right, #ffffff, #000);
        background-color: #000;
        position: relative;
    }

    /* 登录功能框 */
    .login-container {
        width: 600px;
        height: 400px;
        background-color: rgba(255, 255, 255, 0.3);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 25px;
    }

    /* 登录的标题 */
    .login-caption {
        font-size: 50px;
        text-align: center;
        color: #000;
        margin-bottom: 65px;
    }

    /* 表单输入框的容器 */
    .el-form-item__content {
        position: relative;
    }

    /* 小图标定位 */
    .el-icon-s-custom,
    .el-icon-lock {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: #000;
        font-size: 24px;
        margin-left: 1px;
        z-index: 2;
    }

    /* .输入框内容的填充 */
    .demo-ruleForm>>>.el-input__inner {
        padding: 0 28px;
    }

    .demo-ruleForm {
        margin-bottom: 50px;
    }

    /* 登录按钮 */
    .login-button {
        width: 200px;
        height: 45px;
        font-size: 20px;
        background-color: #000;
        color: #ffffff;
        text-align: center;
        line-height: 45px;
        margin: 0 auto;
        cursor: pointer;
        transition: all 0.3s;
    }

    .login-button:hover {
        background-color: #ffffff;
        color: #000;
    }
</style>


// WEBPACK FOOTER //
// src/pages/adime/login.vue